import React, { Component } from 'react'
import intl from 'react-intl-universal'
import PropTypes from 'prop-types'
import { Scrollbars } from 'react-custom-scrollbars'
import moment from 'moment'
import 'moment-timezone'
import shortid from 'shortid'

// react-dates
import 'react-dates/initialize'
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react/index'
import object_value from '../api/object_value'

moment.locale('en')

const DURATION_UNIT = 'minutes'

@inject('create_experience')
@observer
class EventItem extends Component {
  constructor (args) {
    super(...args)

    this.state = {}
  }

  handleRemove = (event) => {
    event.preventDefault()
    const {index, create_experience} = this.props
    create_experience.event__remove(index)
  }
  handleChangeDate = (moment) => {
    // Save date_day moment
    const {index, create_experience} = this.props
    let zero_time_moment = moment
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)
    create_experience.event__update(index, {date_day: zero_time_moment})

    // Set date
    const experience_event = create_experience.events[index]
    const {date_time} = experience_event
    if (date_time > -1) {
      let date = zero_time_moment.add(date_time, 'minutes')//.toDate()
      create_experience.event__update(index, {date})
    }
  }
  handleChangeTime = (event) => {
    // Save time
    const time = event.target.value
    console.log('EventItem.js - handleChangeTime()', time)
    const {index, create_experience} = this.props
    create_experience.event__update(index, {date_time: time})

    // Set date
    const experience_event = create_experience.events[index]
    const {date_day} = experience_event
    let date_day_moment = date_day.tz('Europe/Berlin')
      .set('hour', 0)
      .set('minute', 0)
      .set('second', 0)
      .set('millisecond', 0)
    // if (date_day instanceof Date) {
      let date = date_day.add(time, 'minutes')//.toDate()
      create_experience.event__update(index, {date})
    // }
  }
  handleChangeEndTime = async (event) => {
    // Save end time
    const time = event.target.value
    console.log('EventItem.js - handleChangeEndTime()', time)
    const {index, create_experience} = this.props
    create_experience.event__update(index, {date_end_time: time})

    // Get duration
    const experience_event = create_experience.events[index]
    const {date_time, date_end_time} = experience_event
    if (date_time !== null && date_end_time !== null) {
      console.log('EventItem.js - handleChangeEndTime() - duration - date_time, date_end_time', date_time, date_end_time)
      let a = parseInt(date_time)
      let b = parseInt(date_end_time)

      let duration = a <= b
        ? b - a
        : 24 * 60 - a + b

      console.log('EventItem.js - update() - duration - duration', duration)
      create_experience.set('duration', duration)
    }
  }
  handleTimePickerOpen = () => {
    console.log('EventItem.js - handleTimePickerOpen()')
    const {index, create_experience} = this.props
    let show_time_picker = !create_experience.events[index].show_time_picker
    create_experience.event__update(index, {show_time_picker})
  }

  render () {
    const {index, create_experience} = this.props
    const {format__event_time_label, time_options} = create_experience
    const event = create_experience.events[index]

    return (
      <div className={index !== 0
        ? 'b-form-row b-form-row_events'
        : 'b-form-row'}>
        <div className='b-form-item b-form-item_x'>
          <div className='b-form-item-DatePickerWrap filled'>
            <SingleDatePicker
              displayFormat='DD.MM.YYYY'
              // defaultValue={this.state.date}
              date={event.date_day} // momentPropTypes.momentObj or null
              onDateChange={this.handleChangeDate} // PropTypes.func.isRequired
              focused={this.state.focused} // PropTypes.bool
              onFocusChange={({focused}) => this.setState({focused})} // PropTypes.func.isRequired
              firstDayOfWeek={1}
              navPrev={<div className='b-form-item-DatePicker-arrow left' />}
              navNext={<div className='b-form-item-DatePicker-arrow right' />}
              hideKeyboardShortcutsPanel
              readOnly
              noBorder
              required
            />
          </div>
        </div>

        <div className='b-form-item b-form-item_x'>
          <button className='b-button b-button_x b-button_select'
                  key={shortid.generate()}
                  type='button'
                  disabled={!event.date_day}
                  onClick={this.handleTimePickerOpen}
          >
            {format__event_time_label(index)}
          </button>

          {event.show_time_picker &&
            [<div className='b-select-window-outer'
                  key={shortid.generate()}
                  onClick={this.handleTimePickerOpen} />,
            <div className='b-select-window'
                 key={shortid.generate()}>
              <div className='b-select-window-inner'>
                <div className='b-select-window-column'>
                  <div className='b-select-window-title'>
                    {intl.get('Start')}
                  </div>
                  <div className={index === 0
                    ? 'b-select-window-options b-select-window-options_two-columns'
                    : 'b-select-window-options'}>
                    <Scrollbars
                      style={{height: 160}}>
                      {time_options(index).map(o =>
                        <label key={shortid.generate()}
                               className='b-select-window-options-option'>
                          <input type='radio'
                                 id={'start_time' + index}
                                 name={'start_time' + index}
                                 value={o.value}
                                 defaultChecked={parseInt(event.date_time) === o.value ? 'checked' : ''}
                                 onChange={this.handleChangeTime} />
                          <span className='no-wrap'>{o.label}</span>
                        </label>)}
                    </Scrollbars>
                  </div>
                </div>
                {index === 0 &&
                <div className='b-select-window-column'>
                  <div className='b-select-window-title'>
                    {intl.get('End')}
                  </div>
                  <div className={index === 0
                    ? 'b-select-window-options b-select-window-options_two-columns'
                    : 'b-select-window-options'}>
                    <Scrollbars
                      style={{height: 160}}>
                      {time_options(index).map(o =>
                        <label key={shortid.generate()}
                               className='b-select-window-options-option'>
                          <input type='radio'
                                 id={'end_time_' + index}
                                 name={'end_time_' + index}
                                 value={o.value}
                                 defaultChecked={parseInt(event.date_end_time) === o.value ? 'checked' : ''}
                                 disabled={!event.date_time}
                                 onChange={this.handleChangeEndTime} />
                          <span className='no-wrap'>{o.label}</span>
                        </label>)}
                    </Scrollbars>
                  </div>
                </div>}
              </div>
            </div>]}


          {index === 0 && event.date_day && event.date_time && event.date_end_time === null && !event.show_time_picker &&
          <div className='b-form-form-item-message'
               style={{position: 'absolute', top: '100%', marginTop: '0.4rem', fontSize: '1.1rem'}}>
            {intl.get('create_experience.missed_end_time')}.</div>}
        </div>

        {index > 0 &&
        <div className='b-form-item b-form-item_x'>
          <button className='b-button b-button_primary b-button_x'
                  type='button'
                  onClick={this.handleRemove}
          >
            &times;
          </button>
        </div>}
      </div>
    )
  }
}

EventItem.propTypes = {
  create_experience: MobxPropTypes.observableObject,
  duration: PropTypes.number,
  index: PropTypes.number,
  onEventChange: PropTypes.func,
  onEventRemove: PropTypes.func
}

export default EventItem



// WEBPACK FOOTER //
// ./src/components/CreateExperienceEventsItem.js